<div class="custom-message-box">
  <ng-container *ngIf="parameters.title">
    <h2>{{ parameters.title }}</h2>
  </ng-container>
  <ng-container *ngIf="parameters.message">
    <div>
      <span [innerHTML]="parameters.message"></span>
    </div>
  </ng-container>
  <ng-container *ngIf="parameters.information">
    <div>
      {{ parameters.information }}
    </div>
  </ng-container>
  <ng-container *ngIf="parameters && (parameters?.buttons?.length || 0) > 0">
    <div class="messageBox-button-container">
      <button mat-raised-button color="primary" *ngIf="parameters?.buttons?.includes('ok')" (click)="onOk()">OK</button>
      <button mat-raised-button color="primary" *ngIf="parameters?.buttons?.includes('yes')"
        (click)="onYes()">{{ 'button.yes' | translate}}</button>
      <button mat-raised-button color="warn" *ngIf="parameters?.buttons?.includes('no')"
        (click)="onNo()">{{ 'button.no' | translate}}</button>
      <button mat-raised-button color="warn" *ngIf="parameters?.buttons?.includes('cancel')"
        (click)="onCancel()">{{ 'button.cancel' | translate}}</button>
    </div>
  </ng-container>
</div>
